import { useEffect } from "react";
import { motion } from "framer-motion";
import { Rocket } from "lucide-react";
import { playRocket } from "@/lib/sound";
import { useEvent } from "@/context/EventContext";

export const RocketLaunch = ({ onDone }) => {
  const { event } = useEvent();
  useEffect(() => {
    playRocket();
    const t = setTimeout(onDone, 2100);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div className="fixed inset-0 z-50 overflow-hidden bg-[#05020a]" initial={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="rocket-launch">
      {Array.from({ length: 30 }).map((_, i) => (
        <motion.span
          key={`launch-star-${i}`}
          className="absolute h-1 w-1 rounded-full bg-white"
          style={{ left: `${(i * 37) % 100}%`, top: `${(i * 53) % 100}%` }}
          animate={{ y: [0, 900], opacity: [0.2, 1, 0] }}
          transition={{ duration: 1.4 + (i % 4) * 0.2, delay: (i % 6) * 0.08, ease: "easeIn" }}
        />
      ))}
      <motion.div
        className="absolute left-1/2 text-white"
        initial={{ y: "80vh", x: "-50%", scale: 0.9 }}
        animate={{ y: ["80vh", "45vh", "-30vh"], scale: [0.9, 1.1, 0.7] }}
        transition={{ duration: 2, times: [0, 0.35, 1], ease: ["easeOut", "easeIn"] }}
      >
        <div className="relative -rotate-45 drop-shadow-[0_0_30px_var(--accent)]">
          <Rocket size={96} strokeWidth={1.5} />
        </div>
        <motion.span
          className="absolute left-1/2 top-[70%] h-40 w-6 -translate-x-1/2 rounded-full bg-gradient-to-b from-[var(--accent-soft)] via-[var(--accent)] to-transparent blur-[2px]"
          animate={{ scaleY: [0.4, 1.3, 0.9, 1.4], opacity: [0.6, 1, 0.8, 1] }}
          transition={{ duration: 0.4, repeat: Infinity }}
        />
      </motion.div>
      <motion.div className="absolute inset-x-0 bottom-[14vh] text-center" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
        <p className="eyebrow">Giriş başarılı</p>
        <p className="font-display mt-2 text-2xl font-extrabold text-white sm:text-3xl">Kalkış! {event?.event_name}</p>
      </motion.div>
    </motion.div>
  );
};
